import { render, staticRenderFns } from "./campaign-email-verification.vue?vue&type=template&id=631d4934"
import script from "./campaign-email-verification.vue?vue&type=script&lang=js"
export * from "./campaign-email-verification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports